import React, { useState, useEffect, useCallback } from "react";
import { setTitle } from "../helpers/MetaTag";
import Button from "../components/form/Button";
import Textarea from "../components/form/Textarea";
import NoDataFound from "../components/NoDataFound";
import toastr from "toastr";
import { useSelector } from "react-redux";
import Accordian from "../components/Common/Accordian";
import Search from "../components/form/Search";

import { postData } from "../services/api";
import { Document, PDFDownloadLink } from "@react-pdf/renderer";
import CompetenciesReport from "./pdf/CompetenciesReport";
import TrialAlertPopup from "../components/popup/TrialAlertPopup";
import { API_URL } from "../config/host";

import { useTranslation } from "react-i18next";
import { classNames } from "../helper/classNames";
import PositionCompetenciesSkelton from "../components/loader/PositionCompetenciesSkelton";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import DeletePopup from "../components/DeletePopup";
import AddEditPositionPopup from "../components/popup/AddEditPositionPopup";
import ConfirmationPopup from "../components/popup/ConfirmationPopup";
import CompanyPositionCompetenciesPopup from "../components/popup/CompanyPositionCompetenciesPopup";

const CompetenciesAltNew = () => {
  setTitle(
    "Succession Planning Software for your Business with Succession Now | Succession Plan Position Competencies"
  );
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth?.user);
  const isTrial = localStorage.getItem("isTrial");
  const [loading, setLoading] = useState(true);
  const [competenciesData, setCompetenciesData] = useState([]);
  const [competenciesResetData, setCompetenciesResetData] = useState([]);
  const [isUpdate, setIsUpdate] = useState(false);
  const [reload, setReload] = useState(false);
  const [isCancel, setIsCancel] = useState(false);
  const [openAccordionId, setOpenAccordionId] = useState(null);
  const [keyword, setKeyword] = useState("");
  const [allData, setAllData] = useState([]);
  const [enabledTrialPopup, setEnabledTrialPopup] = useState(false);
  const [actionValue, setActionValue] = useState({});
  const [isDisabled, setIsDisabled] = useState(false);
  const [localValues, setLocalValues] = useState({});
  const [enabledDeletePopup, setenabledDeletePopup] = useState({
    isOpen: false,
    data: null,
  });
  const [isOpen, setIsopen] = useState({
    _id: null,
    open: false,
  });
  const [enabledConfirmationPopup, setEnabledConfirmationPopup] =
    useState(false);
  const [enabledPositionPopup, setEnabledPositionPopup] = useState(false);
  const [details, setDetails] = useState({});

  const loadList = useCallback(async () => {
    setLoading(true);
    setIsDisabled(true);
    try {
      const result = await postData("position/list", {
        sortQuery: { ordering: 1 },
        status: 1,
      });
      if (result.data) {
        setCompetenciesData(
          result.data
            .sort((a, b) => {
              if (a.company_id === null && b.company_id !== null) {
                return -1; // 'a' comes before 'b'
              }
            })
            .map((value) => {
              return {
                ...value,
                position_competencies: value?.company_position_competencies
                  ? value?.company_position_competencies
                  : value?.position_competencies,
                different_competencies: value?.different_competencies
                  ? value?.different_competencies
                  : "",
              };
            })
        );
        setCompetenciesResetData(result.data);
        setLoading(false);
        setIsDisabled(false);
      } else {
        console.log("Position message", result.message);
        setLoading(false);
      }
    } catch (error) {
      console.log("Error role catch", error.message);
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadList();
  }, [loadList]);

  const handelUpdate = async (id, index, value, field) => {
    console.log("value", value);
    let temp = [...allData];
    temp[index][field] = value;
    setCompetenciesData(temp);
    setAllData(temp);
  };

  const onCancel = async (e) => {
    setIsCancel(true);
    setCompetenciesData(
      competenciesResetData.map((value, key) => {
        return {
          ...value,
          position_competencies: value?.company_position_competencies
            ? value?.company_position_competencies
            : value?.position_competencies,
          different_competencies: value?.different_competencies
            ? value?.different_competencies
            : "",
        };
      })
    );
    setIsCancel(false);
  };

  const onUpdate = async () => {
    setIsUpdate(true);
    setReload(false);
    try {
      const result = await postData("competency/update", {
        competencies_data: competenciesData,
      });
      if (result.data && result.status === 200) {
        setIsUpdate(false);
        setReload(true);
      } else {
        toastr.error(result.message);
        setIsUpdate(false);
        setReload(false);
      }
    } catch (error) {
      toastr.error(error.message);
      setIsUpdate(false);
      setReload(false);
    }
  };

  const getDownload = (e) => {
    e.preventDefault();
    if (e.target.tagName.toLowerCase() === "a") {
      window.open(e.target.href, "_blank");
    }
  };

  const toggleAccordion = (id) => {
    setOpenAccordionId(openAccordionId === id ? null : id);
  };

  useEffect(() => {
    if (keyword) {
      const filteredArray = competenciesData.filter((item) =>
        item?.name?.toLowerCase().includes(keyword.toLowerCase())
      );
      setAllData(filteredArray.sort((a, b) => a.name?.localeCompare(b.name)));
    } else {
      setAllData(
        competenciesData.sort((a, b) => a.name?.localeCompare(b.name))
      );
    }
  }, [competenciesData, keyword]);

  useEffect(() => {
    if (actionValue && actionValue.button_type === "delete") {
      const loadDeleteRecord = async () => {
        setReload(true);
        try {
          const deleteData = await postData("position/delete", {
            id: actionValue?.row_id,
          });
          if (deleteData.data) {
            loadList();
            toastr.success("Position deleted successfully");
          } else {
            toastr.error(deleteData.message);
          }
        } catch (error) {
          toastr.error(error.message);
        }
        setReload(false);
      };
      loadDeleteRecord();
    } else if (actionValue && actionValue.button_type === "confirm") {
      const importGlobalPosition = async () => {
        setReload(true);
        try {
          const importData = await postData("copy-global-position", {
            type: "succession",
          });
          if (importData.data) {
            setEnabledConfirmationPopup(false);
          } else {
            toastr.error(importData.message);
          }
        } catch (error) {
          toastr.error(error.message);
        }
        setReload(false);
      };
      importGlobalPosition();
    }
  }, [actionValue]);

  return (
    <>
      <div className="relative flex justify-between items-center mb-4 flex-wrap sm:flex-nowrap gap-y-4">
        <div>
          <div className="text-xl md:text-3xl text-slate-800 font-bold">
            {t("succession_plan_position_competencies") + " - "}
            {user?.company_name}
          </div>
          <div className="text-sm md:text-base text-slate-500 mt-1">
            Summary of All {allData?.length} Records
          </div>
        </div>
        <div className="sm:ml-auto flex justify-end items-center space-x-2">
          {isTrial !== 1 ? (
            <>
              <button
                type={"button"}
                className={classNames(
                  "flex justify-center items-center gap-2 bg-teal-500 text-white rounded text-base sm:text-lg h-8 sm:h-10 py-0 px-2 sm:px-3 transition-all duration-200",
                  isDisabled ? "pointer-events-none" : "cursor-pointer"
                )}
                onClick={(e) => getDownload(e)}
                disabled={isDisabled}
              >
                <i className={"fa-fw fa-light fa-download"}></i>
                <div
                  className={"text-xs sm:text-sm font-medium whitespace-nowrap"}
                >
                  <PDFDownloadLink
                    document={
                      <Document>
                        <CompetenciesReport
                          data={competenciesData}
                          user={user}
                          companyLogo={API_URL + user?.image}
                        />
                      </Document>
                    }
                    fileName="competencies.pdf"
                  >
                    {({ blob, url, loading, error }) =>
                      loading ? t("loading_document") : t("download_pdf")
                    }
                  </PDFDownloadLink>
                </div>
              </button>
              <Button
                buttonType={"button"}
                buttonIcon={
                  isUpdate ? "fa-light fa-spinner fa-spin" : "fa-light fa-check"
                }
                buttonIconPosition={"left"}
                buttonLabel={t("save")}
                functions={onUpdate}
                buttonHasLink={false}
                buttonDisabled={isUpdate}
              />
            </>
          ) : (
            <>
              <Button
                buttonClasses={
                  "!bg-slate-200 !text-slate-600 border border-slate-300"
                }
                buttonLabel={t("download_pdf")}
                buttonType={"button"}
                buttonIcon={"fa-regular fa-download"}
                buttonIconPosition={"left"}
                buttonHasLink={false}
                functions={() => {
                  setEnabledTrialPopup(true);
                }}
              />
              <Button
                buttonClasses={
                  "!bg-slate-200 !text-slate-600 border border-slate-300"
                }
                buttonLabel={t("save")}
                buttonType={"button"}
                buttonIcon={"fa-light fa-check"}
                buttonIconPosition={"left"}
                buttonHasLink={false}
                functions={() => {
                  setEnabledTrialPopup(true);
                }}
              />
            </>
          )}
        </div>
      </div>
      <div className="relative flex justify-between items-center mb-4">
        <div className="relative ml-auto flex justify-end items-center gap-3 w-full sm:w-auto">
          <div className="relative w-full">
            <Search placeholder={"Search"} setInput={setKeyword} />
          </div>
          <div className="sm:ml-auto flex justify-end items-center space-x-4">
            <Button
              buttonType={"button"}
              buttonIcon={"fa-solid fa-cloud-arrow-down"}
              buttonIconPosition={"left"}
              buttonLabel={"Import Succession Positions"}
              buttonHasLink={false}
              buttonClasses={
                "!rounded-full !bg-transparent !text-black !border !border-black"
              }
              functions={() => setEnabledConfirmationPopup(true)}
            />
          </div>
          <div
            className="sm:ml-auto flex justify-end items-center space-x-4"
            data-tooltip-id={`buttonAddPosition${23323223}`}
            data-tooltip-place="bottom"
          >
            <Button
              buttonType={"button"}
              buttonIcon={"fa-light fa-plus"}
              buttonIconPosition={"left"}
              buttonLabel={t("add_positions")}
              buttonHasLink={false}
              //   functions={() =>
              //     navigate("/add-position", { state: "/competencies-alt" })
              //   }
              functions={() => setEnabledPositionPopup(true)}
              // buttonLink={"/add-position"}
            />
            <Tooltip
              id={`buttonAddPosition${23323223}`}
              className="!text-xs !bg-teal-500 z-50 rounded py-3 px-6 !opacity-100"
              render={() => (
                <div className="gap-x-1">
                  <div className="text-[13px] font-normal leading-none flex items-center">
                    <div className="font-semibold">Add New Position</div>
                  </div>
                </div>
              )}
            />
          </div>
        </div>
      </div>
      <div className="relative bg-white shadow rounded">
        <div className="">
          <form className="relative divide-y divide-slate-200">
            {allData?.length > 0 ? (
              allData?.map((item, index) => (
                <div className="flex items-start justify-center rounded-lg gap-3">
                  <div className="gap-3 flex-grow flex-shrink">
                    <Accordian
                      key={index}
                      id={index}
                      title={
                        <div className="flex items-center gap-5">
                          {item?.position_competencies ? (
                            <i
                              className="fa-solid fa-circle-check text-green-500 text-sm"
                              title="Has content"
                            ></i>
                          ) : (
                            <i
                              className="fa-regular fa-circle-xmark text-rose-500 text-sm"
                              title="No content"
                            ></i>
                          )}
                          <span>{item.name}</span>
                        </div>
                      }
                      isOpen={openAccordionId === index}
                      toggleAccordion={toggleAccordion}
                    >
                      <div className="max-w-full mx-auto px-2 py-2  space-y-2">
                        {item?.position_competencies && (
                          <>
                            <h1 className="text-base font-bold text-teal-600">
                              {t(
                                "document_position_competencies_in_section_below"
                              )}
                            </h1>

                            <div
                              className="text-gray-700 text-[14px] leading-relaxed"
                              dangerouslySetInnerHTML={{
                                __html: item?.position_competencies || "N/A",
                              }}
                            />
                          </>
                        )}
                      </div>
                    </Accordian>
                  </div>
                  <div className="flex-shrink-0 flex items-start justify-start gap-2 pt-2">
                    <div
                      className="cursor-pointer p-1 rounded  transition"
                      //   onClick={() => setIsopen({ open: true, _id: item?._id })}
                      onClick={() => {
                        setEnabledPositionPopup(true);
                        setDetails(item);
                      }}
                    >
                      <i className="fa-regular fa-pen text-teal-500 hover:text-teal-700 text-base"></i>
                    </div>
                    {(!item?.code || item?.code !== "ceo") && (
                      <div
                        className="cursor-pointer p-1 rounded transition"
                        onClick={() => {
                          if (!isUpdate) {
                            setenabledDeletePopup({
                              isOpen: true,
                              data: item?._id,
                            });
                            //loadDeleteRecord(item?._id);
                          }
                        }}
                      >
                        <i className="fa-regular fa-trash text-rose-600 hover:text-rose-700 text-base"></i>
                      </div>
                    )}
                  </div>
                </div>
              ))
            ) : loading ? (
              <PositionCompetenciesSkelton />
            ) : (
              <NoDataFound label={"No Data Found"} />
            )}
          </form>
        </div>

        {competenciesData?.length > 0 && (
          <div className="py-3 px-3 border-t border-slate-200">
            <div className="flex items-center justify-end gap-4">
              {isTrial !== 1 ? (
                <>
                  <button
                    type={"button"}
                    className={
                      "flex justify-center items-center gap-2 bg-teal-500 text-white rounded text-base sm:text-lg h-8 sm:h-10 py-0 px-2 sm:px-3 transition-all duration-200 cursor-pointer"
                    }
                    onClick={(e) => getDownload(e)}
                  >
                    <i className={"fa-fw fa-light fa-download"}></i>
                    <div
                      className={
                        "text-xs sm:text-sm font-medium whitespace-nowrap"
                      }
                    >
                      <PDFDownloadLink
                        document={
                          <Document>
                            <CompetenciesReport
                              data={competenciesData}
                              user={user}
                              companyLogo={API_URL + user?.image}
                            />
                          </Document>
                        }
                        fileName="competencies.pdf"
                      >
                        {({ blob, url, loading, error }) =>
                          loading ? t("loading_document") : t("download_pdf")
                        }
                      </PDFDownloadLink>
                    </div>
                  </button>
                  <Button
                    buttonType={"button"}
                    buttonIcon={
                      isUpdate
                        ? "fa-light fa-spinner fa-spin"
                        : "fa-light fa-check"
                    }
                    buttonIconPosition={"left"}
                    buttonLabel={t("save")}
                    functions={onUpdate}
                    buttonHasLink={false}
                    buttonDisabled={isUpdate}
                  />
                </>
              ) : (
                <>
                  <Button
                    buttonClasses={
                      "!bg-slate-200 !text-slate-600 border border-slate-300"
                    }
                    buttonLabel={t("download_pdf")}
                    buttonType={"button"}
                    buttonIcon={"fa-regular fa-download"}
                    buttonIconPosition={"left"}
                    buttonHasLink={false}
                    functions={() => {
                      setEnabledTrialPopup(true);
                    }}
                  />
                  <Button
                    buttonClasses={
                      "!bg-slate-200 !text-slate-600 border border-slate-300"
                    }
                    buttonLabel={t("save")}
                    buttonType={"button"}
                    buttonIcon={"fa-light fa-check"}
                    buttonIconPosition={"left"}
                    buttonHasLink={false}
                    functions={() => {
                      setEnabledTrialPopup(true);
                    }}
                  />
                </>
              )}
            </div>
          </div>
        )}
      </div>
      {enabledTrialPopup && (
        <TrialAlertPopup
          isOpen={enabledTrialPopup}
          setIsOpen={(val) => setEnabledTrialPopup(val)}
          getActionValue={(obj) => {
            setActionValue(obj);
          }}
        />
      )}
      {isOpen?.open && (
        <AddEditPositionPopup
          isOpen={isOpen?.open}
          id={isOpen?._id}
          setIsOpen={setIsopen}
          loadList={loadList}
        />
      )}
      {enabledConfirmationPopup && (
        <ConfirmationPopup
          isOpen={enabledConfirmationPopup}
          title={t("confirmation")}
          message={
            "Would you like to import the default positions provided by SuccessionNow into your company? If so, please click the Confirm button to proceed with the import."
          }
          confirmButtonLabel={t("confirm")}
          cancelButtonLabel={t("cancel")}
          setIsOpen={(val) => setEnabledConfirmationPopup(val)}
          getActionValue={(obj) => {
            setActionValue(obj);
          }}
        />
      )}
      {enabledDeletePopup && (
        <DeletePopup
          isOpen={enabledDeletePopup?.isOpen}
          setIsOpen={(val) => setenabledDeletePopup({ isOpen: val })}
          currentId={enabledDeletePopup?.data}
          setLoading={setReload}
          loading={reload}
          getActionValue={(obj) => {
            setActionValue(obj);
            setenabledDeletePopup({ isOpen: false });
          }}
        />
      )}
      {enabledPositionPopup && (
        <CompanyPositionCompetenciesPopup
          isOpen={enabledPositionPopup}
          setIsOpen={(val) => setEnabledPositionPopup(val)}
          data={details}
          setData={setDetails}
          loadList={loadList}
          isAdmin={true}
        />
      )}
    </>
  );
};

export default CompetenciesAltNew;
